import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "../context/CartContext";

const navLinks = [
  { to: "/shop?gender=men", label: "Men" },
  { to: "/shop?gender=women", label: "Women" },
  { to: "/shop", label: "Shop" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const { count, setOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 w-full bg-white/85 backdrop-blur-md border-b border-[color:var(--ssm-border)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>

        <Link
          to="/"
          data-testid="logo-home-link"
          className="font-display text-xl md:text-2xl tracking-tight font-medium"
        >
          Simple Style Mode
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide ssm-underline-link ${isActive ? "text-black" : "text-neutral-700"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          data-testid="cart-open-btn"
          onClick={() => setOpen(true)}
          className="relative flex items-center gap-2 text-sm"
          aria-label="Open cart"
        >
          <ShoppingBag size={20} />
          <span className="hidden sm:inline text-xs tracking-[0.2em] uppercase">Cart</span>
          {count > 0 && (
            <span
              data-testid="cart-count-badge"
              className="absolute -top-2 -right-3 bg-black text-white text-[10px] min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full"
            >
              {count}
            </span>
          )}
        </button>
      </div>

      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-[color:var(--ssm-border)] bg-white"
        >
          <nav className="flex flex-col px-6 py-4 gap-4">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                onClick={() => setMobileOpen(false)}
                className="text-base py-2"
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};
